












import Vue from 'vue'
export default Vue.extend({
  name: 'section-edit-chip',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
})
